import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions} from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Rx';
import { AppConfig } from 'app/app.config';
import { environment } from 'environments/environment';

@Injectable()
export class SolicitudService {
  public token: string;
  private headers: Headers = new Headers({'Content-Type': 'application/json'});
  constructor(private http: Http, private config: AppConfig) { }


get(idsolicitud: string) {
  // tslint:disable-next-line:max-line-length
  return this.http.get(environment.apiUrl + '/SOLICITUD/' + idsolicitud , this.jwt()).map((response: Response) => response.json());
}


private jwt() {
  // create authorization header with jwt token
  const currentUser = JSON.parse(localStorage.getItem('currentUser'));
  if (currentUser && currentUser.token) {
      const headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
      return new RequestOptions({ headers: headers });
  }
}


private jwtBlob() {
  // create authorization header with jwt token
  const currentUser = JSON.parse(localStorage.getItem('currentUser'));
  if (currentUser && currentUser.token) {
      const headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
      // headers = new Headers({ResponseContentType : Text});
      return new RequestOptions({ headers: headers });
  }
}
}



// WEBPACK FOOTER //
// /app/src/app/services/solicitud.service.ts